<!--<button (click)="encryptData()">click</button>
<button (click)="decryptData()">Decrypt</button>

<button type="btn btn-success" class="btn btn-block btn-success btn-lg col-md-12 col-xs-12" (click)="testeAss()" >Quero Assinar</button>
-->

<form [formGroup]="this.assinaturaForm" (ngSubmit)="enviarDados(assinaturaForm.value)"
  style="background-color: rgb(202, 202, 202,0.5);">
  <div class="row justify-content-md-center" id='top'>
    <img src="../../../assets/imgs/logoT.png">

  </div>
  <div class="row justify-content-md-center">
    <div class=" col-md-9 col-xs-12">
      <div class="card card-default " style="margin-top: 10px;">
        <div class="card-header d-flex justify-content-center" style="background-color: #FF914D;">
          <div class="card-title ">
            <H3 class="mb-0" style="color: #ffffff;">DIGITE SEUS DADOS</H3>

          </div>

        </div>

        <div class="card-body">



          <div class="row">

            <div class="form-group col-md-6 col-xs-12 ">
              <label for="funcionamentoId">Nome Completo</label>
              <input type="text" class="form-control" id="nome" required formControlName="nome">
            </div>
            <div class="form-group col-md-6 col-xs-12 ">
              <label for="EntregaId">Email do Contato</label>
              <input type="text" class="form-control" id="email" required formControlName="email"></div>
          </div>

          <div class="row" style="padding-left: 7.5px;">
            <div class="form-check col-md-6 col-xs-12">
              <input type="checkbox" class="form-check-input" id="souCNPJ" (click)="souCnpj($event)">
              <label class="form-check-label" for="souCNPJ">Sou CNPJ</label>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-6 col-xs-12 " *ngIf="!cnpjUser">
              <label for="CPF">CPF do Contato</label>
              <input type="text" class="form-control" id="CPF" required formControlName="cpf" mask="000.000.000-00"
                [showMaskTyped]="true" (keyup)="onKey()" [(ngModel)]="cpfecnpj">
              <label class="col-form-label" style=" color:red;font-size: smaller;" for="CPF"
                *ngIf="!cnpjUser && cpf && !cpf.pristine &&  cpf.invalid "><i class="far fa-times-circle"></i>CPF
                inválido</label>

            </div>

            <div class="form-group col-md-6 col-xs-12 " *ngIf="cnpjUser">
              <label for="CPF">CNPJ da empresa</label>
              <input type="text" class="form-control" id="CNPJ" required formControlName="cpf" mask="00.000.000/0000-00"
                [showMaskTyped]="true" (keyup)="onKey()" [(ngModel)]="cpfecnpj">
              <label class="col-form-label" style=" color:red;font-size: smaller;" for="CNPJ"
                *ngIf="cnpjUser && cpf && !cpf.pristine &&  cpf.invalid "><i class="far fa-times-circle"></i>CNPJ
                inválido</label>

            </div>
            <div class="form-group col-md-6 col-xs-12 ">
              <label for="EntregaId">Whatsapp do Contato</label>
              <input type="text" class="form-control" id="whats" required formControlName="telCel" mask="(00)00000-0000"
                [showMaskTyped]="true" (blur)="whatsBlur()" ></div>
          </div>


          <div class="row">
            <div class="form-group col-md-4 col-xs-12 ">
              <label for="funcionamentoId">Data de Nascimento</label>
              <input type="text" class="form-control" id="nascimento" required formControlName="nascimento"
                mask="00/00/0000" [showMaskTyped]="true">
            </div>
          </div>

          <hr>

          <div class="row">
            <div class="form-group col-md-3 col-xs-12 ">
              <label for="funcionamentoId">CEP</label>
              <input type="text" class="form-control" id="CEP" required formControlName="cep" mask="00000-000"
                [showMaskTyped]="true">
            </div>
            <div class="form-group col-md-6 col-xs-12 ">
              <label for="EntregaId">Logradouro</label>
              <input type="text" class="form-control" id="rua" required formControlName="rua"></div>
            <div class="form-group col-md-3 col-xs-12 ">
              <label for="EntregaId">Numero</label>
              <input type="text" class="form-control" id="numero" required formControlName="ruaNum"></div>
          </div>


          <div class="row">
            <div class="form-group col-md-3 col-xs-12 ">
              <label for="funcionamentoId">Bairro</label>
              <input type="text" class="form-control" id="bairro" required formControlName="bairro">
            </div>
            <div class="form-group col-md-5 col-xs-12 ">
              <label for="EntregaId">Cidade</label>
              <input type="text" class="form-control" id="cidade" required formControlName="cidade"></div>
            <div class="form-group col-md-4 col-xs-12 ">
              <label for="EntregaId">Estado</label>
              <input type="text" class="form-control" id="estado" required formControlName="estado"></div>
          </div>

          <div class="row">
            <div class="form-group col-md-12 col-xs-12 ">
              <label for="funcionamentoId">Complemento</label>
              <input type="text" class="form-control" id="complemento" formControlName="complemento">
            </div>

          </div>

        </div>
      </div>


    </div>

  </div>

  <hr>



  <div class="row justify-content-md-center" style="background-color: #E4E4E4;">
    <div class=" col-md-9 col-xs-12">
      <div class="card card-default " style="margin-top: 10px;">
        <div class="card-header d-flex justify-content-center" style="background-color: #FF914D;">
          <div class="card-title ">
            <H3 class="mb-0" style="color: #ffffff;" *ngIf="formaPagamento == 'Boleto'" >PAGAMENTO NO BOLETO</H3>
            <H3 class="mb-0" style="color: #ffffff;" *ngIf="formaPagamento != 'Boleto'" >PAGAMENTO NO  CARTÃO</H3>

          </div>

        </div>
        <div class="card-body">



          <div class="row justify-content-md-center">
            <p>Será cobrado <b> {{this._idExiste}}mente</b>, o valor de <b> {{valor | currency: 'BRL'}}</b> via
              <b *ngIf="formaPagamento != 'Boleto'"  >Cartão de crédito</b>
              <b *ngIf="formaPagamento == 'Boleto'"  >Boleto</b>
              .</p>
          </div>
<hr>
<div  *ngIf="this.boleto" >
  <div class="row justify-content-md-center">
    <div class="form-check">
      <input type="checkbox" class="form-check-input" id="boleto" (click)="pagamentoTipo($event)">
      <label class="form-check-label" for="boleto"><b>QUERO PAGAR NO BOLETO</b></label>
    </div>

</div>
  <hr>
</div>


          <div class="row justify-content-md-center" *ngIf="formaPagamento != 'Boleto'" >

            <div class="callout callout-info col-md-5">
              <div class="row justify-content-md-center">
                <h5> Dados do Cartão de Crédito</h5>
              </div>
              <hr>
              <div class="row">
                <div class="form-group col-md-12 col-xs-12 ">
                  <input type="text" class="form-control" id="ccTitular" required placeholder="Nome do Titular"
                    formControlName="ccTitular">
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-12 col-xs-12 ">
                  <input type="text" class="form-control" id="ccNum" required placeholder="Numero do cartão"
                    formControlName="ccNum" mask="0000 0000 0000 0000" [showMaskTyped]="true"  >
                </div>
              </div>


              <div class="row">
                <div class="form-group col-sm-3">
                  <select class="form-control" formControlName="ccMes">
                    <ng-container *ngFor="let item of this.mes">
                      <option>{{item.id}}</option>
                    </ng-container>
                  </select>
                  <label class="col-form-label" style=" color:red;font-size: smaller;" for="ccMes"
                    *ngIf="ccMes && !ccMes.pristine &&  ccMes.value.length != 2"><i
                      class="far fa-times-circle"></i></label>
                </div>
                <div class="form-group col-sm-4">
                  <select class="form-control" formControlName="ccAno">
                    <ng-container *ngFor="let item of this.ano">
                      <option>{{item.id}}</option>
                    </ng-container>
                  </select>
                  <label class="col-form-label" style=" color:red;font-size: smaller;" for="ccAno"
                    *ngIf="ccAno && !ccAno.pristine &&  ccAno.value.length != 4"><i
                      class="far fa-times-circle"></i></label>

                </div>
                <div class="form-group col-md-3 col-xs-12 ">
                  <input type="text" class="form-control" id="ccCVD" required placeholder="000" formControlName="ccCVD"
                    mask="000" [showMaskTyped]="true" >
                  <label class="col-form-label" style=" color:red;font-size: smaller;" for="ccCVD"
                    *ngIf="ccCVD &&!ccCVD.pristine &&  ccCVD.value.length != 3"><i
                      class="far fa-times-circle"></i></label>

                </div>
              </div>
            </div>
          </div>


          <hr>
          <div class="row justify-content-md-center">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="exampleCheck1" (click)="termosdeUso($event)"
                formControlName="termos" required>
              <label class="form-check-label" for="exampleCheck1"><b>LI E ACEITO OS </b><a (click)="modalTermos()"
                  style="cursor: pointer; color: blue;"><b>TERMOS DE USO</b></a></label>
            </div>
          </div>
          <hr>
          <div class="row justify-content-md-center">
            <img class="responsive" src="../../../assets/imgs/secure.png" style="max-width: 250px;">
          </div>
          <div class="row" style="margin-top: 10px;">
            <button type="submit" class="btn btn-block  btn-lg col-md-12 col-xs-12" style="background-color: #3060b4;color: white;font-size: xx-large;"
              [disabled]='!assinaturaForm.valid '>Quero Assinar</button>
          </div>


        </div>

      </div>
    </div>
  </div>
  <!--
<div>{{ assinaturaForm.value | json}}</div>
<div>{{ assinaturaForm.valid | json}}</div>-->

</form>


<div class="modal fade show" id="termosModal" style=" padding-right: 17px;" aria-modal="true" role="dialog">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header ">
        <div class="row d-flex justify-content-center">
          <h4 class="modal-title mb-0">Termos de Uso</h4>
        </div>

        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <h5 style="text-align: justify;">Ao assinar e utilizar a plataforma <b>Yourder</b>, você concorda em aceitar e
          aderir na sua totalidade, com
          os
          Termos e Condições de Uso e afirma para todos os efeitos legais, que é maior de 18 anos e tem competência para
          fazê-lo.</h5>
        <b>
          <h6>SERVIÇOS OFERECIDOS</h6>
        </b>
        <p>1.1 - A plataforma Yourder, designada CONTRATADA, têm por finalidade viabilizar e auxiliar, através de nosso
          software de atendimento, nas atividades como anotação de pedidos com a ferramenta denominada Comanda Digital,
          e intermediar a relação entre o dono de estabelecimento comercial alimentício, designado CONTRATANTE, com o
          usuário final no que concerne a pedidos de produtos alimentícios na modalidade delivery.</p>
        <p>1.2 - A CONTRATADA fornece ao CONTRATANTE uma LICENÇA de uso de Software no Modelo SaaS (Software como
          Serviço), que lhe garante acesso ao sistema completo de acordo com o plano e prazo de uso escolhido pelo
          CONTRATANT</p>
        <p>1.3 - É de responsabilidade do CONTRATANTE configurar suas informações e produtos na plataforma com auxílio
          de tutoriais e suporte técnico da CONTRATADA.</p>
        <p>1.4 - O CONTRATANTE fica ciente de que o Yourder é um serviço licenciado e não um software adquirido,
          portanto, o mesmo terá acesso aos serviços apenas enquanto o sistema estiver devidamente licenciado. Em caso
          de cancelamento do serviço ou inadimplência, o CONTRATANTE perderá o acesso a plataforma e seu sistema de
          Delivery deixará de funcionar.</p>
        <p>1.5 - O Sistema Yourder não funciona sem estar associado a um servidor. E por preservação de nossa
          tecnologia, programação e conteúdo, A CONTRATADA trabalha apenas com os Próprios Servidores Dedicados de
          última tecnologia, onde estão instalados nossos softwares.</p>
        <p>1.6 - O Sistema Yourder possui personalização apenas para fotos de produtos e estilização da página de
          cardápio online do CONTRATANTE, sendo assim as alterações e melhorias na plataforma são realizadas para
          atender a todos os usuários</p>
        <p>1.7 - O Sistema Yourder pode ser utilizado diretamente do Navegador pelo computador ou smartphone (Android ou
          IOS) do CONTRATANTE, cabendo ao mesmo informar e relatar quando ocorrer alguma incompatibilidade.</p>
        <b>
          <h6>PAGAMENTO, CANCELAMENTO E REEBOLSO</h6>
        </b>
        <p>2.1 - O Serviço serão considerados como efetivos e integralmente prestados a partir da data da assinatura,
          sendo certo que o prazo de assinatura de cada plano (seja ele mensal, semestral ou anual) será iniciado de tal
          data, independentemente do seu acesso efetivo à Plataforma.</p>
        <p>2.2 - Assinaturas efetuadas por meio de Cartão de Crédito: Quando da realização da assinatura, as informações
          do seu cartão de crédito podem ser necessárias. Ao assinar com cartão de crédito VOCÊ CONCORDA QUE SEJAM
          COBRADOS NO SEU CARTÃO DE CRÉDITO os valores em razão da contratação
          dos Serviços não disponibilizados gratuitamente pela Yourder.</p>
        <p>2.3 - Na hipótese de contratação do plano mensal, semestral ou anual com lançamento das parcelas no cartão de
          crédito, você se compromete a manter disponibilidade de limite no cartão de crédito até o final do pagamento
          do plano contratado.</p>
        <p>2.4 - Plano Mensal: Como nossas assinaturas são pagamentos recorrentes, o cancelamento precisa ser realizado
          antes da cobrança da mensalidade. Assim, o cancelamento corresponderá a interrupção das cobranças futuras e
          seu acesso ao sistema continuará ativo até a data da próxima renovação. Nesses casos, como o serviço permanece
          ativo, não haverá reembolso ou estorno do pagamento.</p>
        <p>2.5 - Plano Semestral e Anual: O cancelamento durante a vigência do plano implica apenas na não renovação
          automática. Assim como no plano mensal, o plano anual ou semestral permanecerá ativo até o fim da vigência do
          plano, sendo apenas cancelada a renovação do plano para o próximo período. Nós não realizamos estorno parcial
          do plano semestral ou anual.</p>
        <p>2.6 - A contratação semestral ou anual concede ainda ao cliente um desconto significativo no preço cobrado em
          relação à contratação mensal, mas, em contrapartida a esse desconto, a assinatura anual não permite que o
          cliente efetue o cancelamento do serviço antes do término do prazo. O cliente somente pode cancelar a
          assinatura semestral ou anual durante os primeiros 7 (sete) dias seguintes à data da contratação do serviço,
          que é justamente o prazo de arrependimento determinado pela legislação, mais especificamente pelo Artigo 49 do
          Código de Defesa do Consumidor (Lei n.º 8.078/90). Caso o cliente cancele o serviço contratado dentro do
          referido prazo, a Yourder estorna o valor eventualmente adiantado. Entretanto, caso o cliente não cancele o
          serviço dentro do prazo de arrependimento estabelecido pela lei, o serviço não poderá ser cancelado, devendo o
          cliente cumprir com a assinatura contratada</p>
        <p>2.7 - O CONTRATANTE poderá cancelar os serviços quando quiser com uma solicitação de cancelamento através do
          nosso whatsapp de atendimento ou chat.</p>
        <p>2.8 - O cancelamento é livre não sendo necessário tempo mínimo de permanência e não haverá cobrança de nenhum
          tipo de taxa ou multa de cancelamento. A efetivação do cancelamento pode levar até 2 dias úteis após a
          solicitação.</p>
        <p>2.9 - Quando cancelar o serviço, o CONTRATANTE deve estar ciente de que todo o conteúdo será colocado
          'offline' imediatamente e depois de 3 meses será apagado sem possibilidade de recuperação dos dados e/ou
          arquivos.</p>
        <p>2.10 - O não-pagamento das mensalidades da Plataforma Yourder resultarão em:
        </p>
        <ul>
          <li>
            Seu acesso a plataforma será limitado aos relatórios e a área de assinatura
          </li>
          <li>
            Seu conteúdo ficará 'offline' e seus clientes não conseguirão comprar com você
          </li>
          <li>
            Todo seu conteúdo poderá ser deletado após 3 meses de inadimplência.
          </li>
        </ul>
        <p>2.11 - Haverá uma tolerância máxima de 3 dias após o vencimento da mensalidade. Se uma conta ficar ‘offline’
          por falta de pagamento ela poderá ser reativada em até 1 dia útil após confirmação do pagamento do servidor.
        </p>
        <b>
          <h6>OBRIGAÇÃO DO CONTRATANTE</h6>
        </b>
        <p>3.1 - O CONTRATANTE tem total responsabilidade no que se refere ao seu login e senha se comprometendo a não
          divulgar o acesso à terceiros. Dessa forma fica ao CONTRATANTE a exclusiva responsabilidade sobre qualquer
          alteração e/ou cadastro de produtos alimentícios na plataforma, que seja feita com o uso de login e senha de
          sua titularidade.</p>
        <p>3.2 - Fica sob responsabilidade do CONTRATANTE a personalização da sua loja para que fique com a aparência
          desejada.</p>
        <p>3.3 - É de exclusiva responsabilidade do CONTRATANTE o cadastro de produtos no sistema, incluindo
          acompanhamentos e preços. Dessa forma, a plataforma não se responsabiliza por quaisquer erros que possam vir a
          causar problemas entre o contratante e o usuário final, ficando isenta a plataforma Yourder por quaisquer
          erros de digitação ou informação inserida no site do Contratante.</p>
        <p>3.4 - Também é de total responsabilidade do CONTRATANTE a retirada de promoções, assim que estiverem
          indisponíveis, bem como de produtos que não se encontram mais à disposição.</p>
        <b>
          <h6>CONSIDERAÇÕES FINAIS</h6>
        </b>
        <p>4.1 - O CONTRATANTE declara-se ciente de que, em ocasiões incomuns o sistema pode, eventualmente, ficar fora
          do ar, assim como qualquer outro serviço online, mediante ações que fogem ao controle da CONTRATADA.</p>
        <p>4.2 - O CONTRATANTE fica ciente de que a plataforma Yourder utiliza o sistema de banco de dados em nuvem
          gerando backups quando necessário, e todas as informações e dados são armazenados em tempo real, cabendo ao
          CONTRATANTE revisar e sempre manter atualizado suas configurações.</p>
        <p>4.3 - Ao usar o Sistema Yourder, você afirma que está ciente de que seu site e gerenciador funcionam na
          versão "Beta", entende-se que estes estão em fase de testes finais e você está ciente de que existe um risco
          de falha ou perda de conteúdo. Além disso por estar em versão Beta, estamos constantemente alterando e
          melhorando a plataforma, sendo assim você aceita possíveis remoções ou alterações em funcionalidades ou
          aparência e os impactos que estes ajustes podem causar, sendo de sua responsabilidade adaptar-se as
          atualizações. Utilizando o sistema cloud e por ocorrência de fatores externos pode ocorrer do sistema ficar
          fora do ar por alguns minutos repentinamente, trabalhamos incansavelmente para que isso não ocorra, mas você
          deve estar ciente que seu acesso pode ficar fora do ar por alguns momentos, horas, dias ou até mesmo semanas
          no pior cenário. Não utilize a plataforma se você não pode assumir este risco.</p>
        <p>4.4 - No improvável, mas possível caso de perda de conteúdo em nosso banco de dados ou a falha do sistema,
          você teria que reconfigurar seu cardápio, informações ou parte do sistema. Como você está ciente dos riscos,
          você concorda em não responsabilizar o Sistema Yourder, nem tão pouco qualquer sócio, funcionário, diretor, ou
          representante da CONTRATADA, por qualquer falha ou perda de conteúdo.</p>
        <p>4.5 - Os Termos e Condições de Uso podem ser modificados a qualquer momento. Qualquer alteração dos Termos e
          Condições de Uso estará em vigor assim que for publicada no website da empresa. Você concorda em aderir às
          possíveis mudanças neste Termo Condicional de Uso quando você inicia o uso e continua usando os serviços da
          Plataforma Yourder. Portanto, é importante ler este Termo Condicional de Uso regularmente para garantir que
          você esteja atualizado com qualquer alteração.</p>
        <b>
          <h6>POLÍTICA DE PRIVACIDADE</h6>
        </b>
        <p>Todos os nossos usuários (Visitantes, Donos de Deliverys e seus Clientes) devem ler com atenção nossa
          Política de Privacidade, antes de navegar no site da Yourder.</p>
        <p>Esta Política de Privacidade aplica-se a todos os usuários seja ele Visitante, Dono de Delivery e Compradores
          Finais.</p>
        <p>Ao se cadastrar na Yourder, o Visitante, Dono de Delivery e Cliente Final garantem de forma expressa que é
          plenamente capaz, nos termos da legislação vigente, para exercer e gozar de todos os produtos/serviços</p>
        <p>Esta Política de privacidade aborda temas como: coleta, uso, armazenamento, tratamento e proteção dos dados
          pessoais dos usuários do Yourder, com a finalidade de demonstrar transparência quanto a este assunto.</p>
        <p>A Yourder guarda com cautela todos os dados de que tenha posse utilizando as mais modernas tecnologias para
          garantir a segurança dos mesmos.</p>
        <p>O usuário que navegar no site da Yourder ou contratar os seus serviços, declara estar de ciente e de acordo
          com os termos desta Política de Privacidade.</p>
        <p>A Yourder se compromete em zelar pela privacidade e a segurança de seus usuários e visitantes durante todo o
          processo de navegação e pedido através de nosso sistema de Delivery. Os dados cadastrais dos Visitantes, Donos
          de Delivery e seus Clientes finais não são vendidos, trocados ou divulgados para terceiros, exceto quando
          essas informações são necessárias para o processo de entrega de Pedidos ou para participação em promoções
          solicitadas pelos usuários.</p>
        <p>A Yourder utiliza cookies e os dados dos usuários são registrados de forma automatizada, dispensando
          manipulação humana. O presente dispositivo é utilizado como benefício aos usuários respeitando os limites da
          legislação vigente.</p>
        <p>Ao pagar a licença na Yourder, o Dono do estabelecimento está ciente que o meio de pagamento online utilizado
          é fornecido por uma empresa prestadora de serviço contratada. Por essa razão, o usuário comprador autoriza,
          para que seja possível concretizar a compra, o cadastro junto da empresa contratada. Ressaltando que essa
          empresa terceirizada é idônea,cumpre com a legislação em vigor, e atende aos critérios de segurança de dados,
          bancários e pessoais, exigidos pela Yourder e legislação pertinente.</p>
        <p>A Yourder poderá cancelar o cadastro dos usuários, caso receba denúncia ou verifique que o mesmo está sendo
          utilizado para práticas ilícitas ou contrárias às nossas políticas.</p>
        <p>Os Visitante, Donos de Delivery ou Cliente final consente de forma livre e expressa que seus dados e
          informações sejam coletados, armazenados, tratados e compartilhados, conforme as regras dispostas nesta
          Política de Privacidade.</p>
        <p>Aconselhamos expressamente a NÃO divulgação por parte dos seus usuários da senha de cadastro em nossos sites
          e sistemas de Delivery a terceiros. Sendo o acesso disponibilizado a terceiros de inteira responsabilidade do
          usuário que forneceu os dados de acesso</p>
        <p>A Yourder declara que todos os dados informados por seus usuários terão tratamento de acordo com a Lei Geral
          de Proteção de Dados. Vale ressaltar que os dados de formas de pagamento são assegurados pela empresa
          contratada, pela Yourder, responsável pela operação de pagamento e proteção dessa operação.</p>
        <p>O Dono do Delivery se responsabiliza pelo sigilo dos dados de seus clientes e reconhece ser o único e
          exclusivo responsável pelos produtos divulgados e vendidos através de nossa plataforma de Delivery.</p>
        <p>Quando um usuário se cadastra, fornece informações tais como: nome, data de nascimento, CPF, endereço
          eletrônico, endereço de correspondência, senha, número de telefone e demais informações pertinentes à operação
          ou ao benefício.</p>
        <p>Além dessas informações iniciais de cadastro, o usuário pode ainda fornece mais informações, bem como
          informações de localização e informações dos seus dispositivos. Abaixo estão detalhadas quais são essas
          informações. Quando o comprador final se inscreve para comprar os produtos do Dono do Delivery estes terão
          acesso às informações pessoais desse comprador final.</p>
        <p>Para poder realizar a entrega do pedido, a plataforma precisa que o comprador final informe a localização do
          local em que deseja que o pedido seja entregue, a localização é fornecida pelo endereço que o usuário inserir
          manualmente, após inserido na primeira vez, os dados são armazenados no navegador do usuário final para ser
          utilizado na próxima vez que acessar o link do cardápio online do estabelecimento.</p>
        <p>A Yourder pode obter informações não-pessoais, ou seja, dados que não permitem a associação direta com
          qualquer pessoa especificamente. São exemplos de dados não-pessoais a idade do indivíduo, preferências
          individuais, idioma, CEP e código de área.</p>
        <p>A Yourder pode usar as informações coletadas para desenvolver e melhorar os produtos e serviços prestados e
          nossos usuários além de:</p>
        <ul>
          <li>
            Aprimorar nossos serviços
          </li>
          <li>Verificar a identidade dos usuários.</li>
          <li>Encontrar e corrigir problemas.</li>
          <li>Proteger nossa infraestrutura.</li>
        </ul>
        <p>As informações que a Yourder coleta dos usuários são armazenadas em serviços de nuvem confiáveis da empresa
          Google Cloud. Buscamos sempre parceiros que empregam alto nível de segurança no armazenamento dos dados.</p>
        <p>Os dados serão armazenados pelo período necessário para as finalidades apresentadas nos Termos e Condições de
          Uso e nesta Política de Privacidade, respeitando o período de retenção de dados determinado pela legislação
          aplicável.</p>
        <p>Caso o usuário solicite a exclusão de sua conta, as suas informações pessoais fornecidas durante a utilização
          dos nossos serviços serão excluídas definitivamente seguindo a legislação vigente.</p>
        <p>Em alguns casos, podemos reter informações dos usuários mesmo que este exclua sua conta caso seja necessário
          para interesses comerciais legítimos.</p>
        <p>Poderemos compartilhar informações com autoridades policiais ou judiciais, autoridades públicas caso seja
          requerido pela legislação aplicável, por decisão judicial e por requisição de autoridades competentes caso
          entenda necessário e adequado em relação a qualquer investigação de ilícitos, infrações a direitos de
          propriedade industrial ou intelectual, ou outra atividade que seja ilegal ou que possa expor a Yourder ou seus
          usuários.</p>
        <p>Os usuários e visitantes do site da Yourder manifestam conhecer e aceitar que poderemos utilizar um sistema
          de coleta de dados de navegação mediante à utilização de cookies. Os cookies são pequenos arquivos que se
          instalam no disco rígido, com uma duração limitada de tempo que ajudam a personalizar os serviços. Também
          serão ofertadas algumas funcionalidades que só estarão disponíveis pelo emprego dos cookies, não usamos os
          cookies com fins alheios à sua operação e ainda que não seja para beneficiar os usuários e a permanência e
          existência dos cookies no computador do usuário dependerão de exclusiva vontade por parte deste e poderão ser
          eliminados de seu computador quando o usuário assim desejar. Não temos controle nem nos responsabilizamos pelo
          uso de cookies por terceiros</p>
        <b>
          <h6>DIREITOS DO USUÁRIO</h6>
        </b>
        <p>Desabilitar os Cookies se seu navegador ou add-on permitir, salvo nos casos nos quais os Cookies sejam
          necessários para a garantia da qualidade da prestação de serviços. Lembre-se de que recusar os Cookies pode
          interferir no uso do website e dos serviços.</p>
        <p>Revisar e editar suas informações pessoais a qualquer momento acessando sua conta e perfil. Sendo o único
          habilitado e responsável para tanto.</p>
        <p>Solicitar a exclusão de seus dados seguindo legislação vigente.</p>
        <p>Solicitar informações de acesso e de alterações da sua conta, além de informações pertinentes aos seus dados.
          Cujo prazo para fornecimento de tais informações serão provisionadas e informadas de acordo com cada
          solicitação.</p>
      </div>
      <div class="modal-footer justify-content-center">
        <button type="button" class="btn btn-default" style="background-color: #FF914D;color: white;"
          data-dismiss="modal">Fechar</button>

      </div>
    </div>
    <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>
